import React, { forwardRef, useCallback } from 'react';
import PropTypes from 'prop-types';

const FocusableCard = forwardRef(function FocusableCard({
  tag: Tag = 'article',
  className,
  onFocus,
  children,
  ...props
}, ref) {
  const onFocusCapture = useCallback(() => {
    onFocus?.();
  }, [onFocus]);

  const onMouseDownCapture = useCallback((e) => {
    e.currentTarget.focus({ preventScroll: true });
  }, []);

  return (
    <Tag
      ref={ref}
      className={className}
      tabIndex={0}
      onFocusCapture={onFocusCapture}
      onMouseDownCapture={onMouseDownCapture}
      {...props}
    >
      {children}
    </Tag>
  );
});

FocusableCard.displayName = 'FocusableCard';

FocusableCard.propTypes = {
  tag: PropTypes.string,
  className: PropTypes.string,
  onFocus: PropTypes.func,
  children: PropTypes.node,
};

export default FocusableCard;
